import { render, staticRenderFns } from "./RiwayatArsip.vue?vue&type=template&id=3f7c92ea&scoped=true"
import script from "./RiwayatArsip.vue?vue&type=script&lang=js"
export * from "./RiwayatArsip.vue?vue&type=script&lang=js"
import style0 from "./RiwayatArsip.vue?vue&type=style&index=0&id=3f7c92ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7c92ea",
  null
  
)

export default component.exports